import React from "react";
import styled from "styled-components";
import Cookies from "js-cookie";

const FooterPopup = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(34, 34, 34, 0.92);
  color: #fff;
  padding: 32px 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 32px;
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  // when on desktop increase the padding to 30%
  @media (min-width: 768px) {
    padding: 32px 15%;
  }
`;

const AcceptButton = styled.button`
  background: #4ea1f7;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 8px 20px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.2s;
  &:hover {
    background: #357ab8;
  }
`;
const CookiePolicyPopup = () => {
  const [show, setShow] = React.useState(() => {
    return !Cookies.get("acceptedCookies");
  });

  const handleAccept = () => {
    Cookies.set("acceptedCookies", "true", { path: "/", expires: 365 * 100 });
    setShow(false);
    window.dispatchEvent(new Event("cookieAccepted"));
  };

  if (!show) return null;
  return (
    <FooterPopup>
      <span>
        We use cookies to improve your experience. Read our&nbsp;
        <a
          href="/cookies"
          target="_blank"
          style={{ color: "#4ea1f7", textDecoration: "underline" }}
        >
          Cookie Policy
        </a>
        .
      </span>
      <AcceptButton onClick={handleAccept}>Accept</AcceptButton>
    </FooterPopup>
  );
};
export default CookiePolicyPopup;
